export default "__VITE_ASSET__C$Iw0Itf__"